module.exports = __webpack_public_path__ + "static/media/blue-plus.721027f4.svg";